import { styled } from "@mui/material";
import { RowStyle } from "../theme/common";
import { COMMON, HeadingStyles, SPACING } from "../theme/palette";
export const ImageSectionStyle = styled("div")(() => ({
    "img": {
        "borderRadius": SPACING.spaces,
        "boxShadow": COMMON.shadow1,
        "width": "100%"
    }
}));
export const RowColumnStyle = styled("div")(() => (Object.assign(Object.assign({}, RowStyle), { "flexDirection": "column" })));
export const SectionTextStyle = styled("div")(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h6), { "div": {
        ">*": {
            "marginBottom": SPACING.spacexs,
            "marginTop": 0,
        },
        "a": {
            "color": theme.palette.primary.main,
            "textDecoration": "Underline"
        },
        "display": "flex",
        "flexDirection": "column",
        "gap": SPACING.spacexs,
        "h1": Object.assign({}, HeadingStyles.h2),
        "h1, h2, h3, h4, h5, h6": {
            "color": theme.palette.primary.dark,
        },
        "h2": Object.assign({}, HeadingStyles.h3),
        "h3": Object.assign({}, HeadingStyles.h4)
    } })));
